// @ts-nocheck
import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import Zoom from '@mui/material/Zoom';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapTheme from "../../styles/SinapTheme";


export default function SearchInput({ lista, setResultado }) {

    const [showSearchInput, setShowSearchInput] = React.useState(false);

    const [contenidoBuscado, setContenidoBuscado] = React.useState({
        buscador: '',
    })

    const handleChange = (prop) => (event) => {
        setContenidoBuscado({ ...contenidoBuscado, [prop]: event.target.value });
    };

    React.useEffect(() => {
        const results = lista.filter(elemento =>
            elemento.toLowerCase().includes(contenidoBuscado.buscador)
        );
        setResultado(results);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contenidoBuscado]);

    const showInput = () => {
        setShowSearchInput(!showSearchInput);
        setResultado(lista);
    }

    return <>
        {
            showSearchInput ?
                <>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={SinapTheme} >
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Zoom in={true} timeout={500}>
                                    <OutlinedInput
                                        id="outlined-adornment-buscador"
                                        placeholder="Buscar correo"
                                        value={contenidoBuscado.buscador}
                                        onChange={handleChange('buscador')}
                                        sx={{ boxShadow: 2, borderRadius: 2, flex: 1 }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <SearchIcon />
                                            </InputAdornment>
                                        }
                                    />
                                </Zoom>
                                <Zoom in={true} timeout={550}>

                                    <IconButton size="large" onClick={showInput}>
                                        <CloseIcon />
                                    </IconButton>

                                </Zoom>
                            </div>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </> :
                <Tooltip title="Activar Buscador">
                    <IconButton size="large" onClick={showInput}>
                        <SearchIcon />
                    </IconButton>

                </Tooltip>
        }
    </>;
}